import React from "react";
import "./OurJourney.css";
import journeyImg from "../assets/Banner2.jpg";

const OurJourney = () => {
  return (
    <div className="journey-page">

      {/* TOP SECTION */}
      <section className="journey-top">

        {/* LEFT */}
        <div className="journey-left">
          <h1>Our Journey</h1>
          <h3>From Passion to Purpose</h3>

          <p>
            Established in 2018, Chirag Hande Private Limited is a leading
            manufacturer and supplier of eco-friendly bags including canvas,
            jute, and BOPP bags. With a skilled team and modern techniques,
            we ensure quality, durability, and design excellence.
          </p>

          <p>
            Guided by our mentor Mr. Chirag Hande, we continuously evolve
            to meet customer needs while promoting sustainability and innovation.
          </p>

          <p>
            Every product we create carries a story of craftsmanship,
            responsibility, and care for the environment.
          </p>
        </div>

        {/* RIGHT */}
        <div className="journey-right">
          <img src={journeyImg} alt="Our Journey" />
        </div>

      </section>

      {/* FEATURES */}
      <section className="journey-bottom">

        <div className="journey-block">
          <h2>🌿 Our Vision</h2>
          <p>
            To promote sustainable living by offering eco-friendly alternatives
            and reducing environmental impact.
          </p>
        </div>

        <div className="journey-block">
          <h2>🧵 Craftsmanship</h2>
          <p>
            Handcrafted products made with precision, blending traditional
            skills with modern designs.
          </p>
        </div>

        <div className="journey-block">
          <h2>💛 Why Choose Us</h2>
          <p>
            Trusted quality, ethical production, and commitment to a greener future.
          </p>
        </div>

      </section>

      {/* CTA */}
      <section className="journey-cta">
        <h2>Carry a Story, Not Just a Bag</h2>
        <p>Explore our eco-friendly collection today</p>
        <button>Explore Collection</button>
      </section>

    </div>
  );
};

export default OurJourney;